import { render, staticRenderFns } from "./TYDan.vue?vue&type=template&id=462c3622&scoped=true"
import script from "./TYDan.vue?vue&type=script&lang=js"
export * from "./TYDan.vue?vue&type=script&lang=js"
import style0 from "./TYDan.vue?vue&type=style&index=0&id=462c3622&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462c3622",
  null
  
)

export default component.exports